export const LINKS = {
  doordash:
    "https://www.doordash.com/store/wings-and-tenders-salinas-46343120/111172607/?cursor=eyJzZWFyY2hfaXRlbV9jYXJvdXNlbF9jdXJzb3IiOnsicXVlcnkiOiI2NyBXSU5HUyAiLCJpdGVtX2lkcyI6W10sInNlYXJjaF90ZXJtIjoiNjciLCJ2ZXJ0aWNhbF9pZCI6LTk5OSwidmVydGljYWxfbmFtZSI6ImFsbCIsInF1ZXJ5X2ludGVudCI6IlNUT1JFX1JYIn0sInN0b3JlX3ByaW1hcnlfdmVydGljYWxfaWRzIjpbMSwxMTAwMzcsMTEwMDQ1LDExMDA1MiwxMTAwNTUsMTEwMDYyLDRdfQ==&pickup=false",
  instagram: "https://instagram.com/67wingstenders",
  tiktok: "https://www.tiktok.com/@saborcomsazon831",
  googleReview: "https://share.google/UuN83CXTMx4OwyEnA",
  yelp: "https://www.yelp.com/biz/67-wings-and-tenders-salinas",
  maps: "https://maps.google.com/?q=124+Griffin+St,+Salinas,+CA+93901",
  phone: "tel:+18316637713",
};

export const INFO = {
  name: "67 WINGS",
  full: "67 Wings & Tenders",
  address: "124 Griffin St, Salinas, CA 93901",
  phone: "831-663-7713",
  instagram: "@67wingstenders",
  tiktok: "@saborcomsazon831",
};

export const IMAGES = {
  heroWings:
    "https://customer-assets.emergentagent.com/job_2a315c77-dbb7-4f38-b74d-ca78d782f3ce/artifacts/leh7i4xl_IMG_2023.webp",
  truck:
    "https://customer-assets.emergentagent.com/job_2a315c77-dbb7-4f38-b74d-ca78d782f3ce/artifacts/l8s9r2j4_IMG_2014.webp",
  elote:
    "https://customer-assets.emergentagent.com/job_wings67-glow/artifacts/5is2u82o_image2%20%281%29.jpeg",
  sauces:
    "https://customer-assets.emergentagent.com/job_wings67-glow/artifacts/evixgwcp_image0%20%284%29.jpeg",
  yelp:
    "https://customer-assets.emergentagent.com/job_wings67-glow/artifacts/pzsjpux6_image1%20%283%29.jpeg",
};

export const TAGLINE = "Bold Flavor. Big Crunch. No Limits.";
export const SUBTAG = "Cooked Fresh · Made To Order · Never Frozen";

export const WINGS_PRICING = [
  { size: "6 Piece", price: "$12" },
  { size: "10 Piece", price: "$18" },
  { size: "20 Piece", price: "$29" },
  { size: "30 Piece", price: "$44" },
];

export const TENDERS_PRICING = [
  { size: "3 Piece", price: "$8" },
  { size: "5 Piece", price: "$14" },
  { size: "7 Piece", price: "$18" },
  { size: "10 Piece", price: "$21" },
];

export const COMBO_NOTES = [
  { icon: "flame", label: "Toss your chicken on any sauce", accent: "for only $1 more" },
  { icon: "fries", label: "Make it a combo", accent: "for only $5 more — includes fries & can soda" },
];

// heat: 1 (less spicy) -> 5 (extreme). signature/new flags for badges.
export const SIGNATURE_FLAVORS = [
  { name: "Elote Blast", desc: "Creamy elote flavor with lime, cheese and a touch of chili. Non spicy.", heat: 1, isNew: true },
  { name: "Garlic Parmesan", desc: "Savory garlic, buttery and cheesy.", heat: 1 },
  { name: "Lemon Pepper", desc: "Zesty lemon with cracked black pepper.", heat: 2 },
  { name: "Mango Habanero", desc: "Sweet mango with a fiery kick.", heat: 3 },
  { name: "Original Buffalo", desc: "Classic. Tangy. Always a favorite.", heat: 3 },
  { name: "Salsa Macha", desc: "Spicy, nutty, and packed with flavor.", heat: 4 },
  { name: "Midnight Mole Bomb", desc: "Rich mole flavor with a smoky, sweet heat and a bold kick.", heat: 4, isNew: true },
  { name: "Sonora Hellfire Chiltepin", desc: "Intense, smoky heat made with authentic chiltepin peppers. Not for the faint of heart.", heat: 5, isNew: true },
];

export const DRY_RUBS = [
  { name: "Lemon Pepper", desc: "Zesty, citrusy and bold." },
  { name: "Spicy Lemon Pepper", desc: "Citrusy with a spicy kick." },
  { name: "Cajun", desc: "Bold, smoky and perfectly seasoned." },
];

export const ADD_ONS = [
  { name: "Loaded Fries", price: "$9.99" },
  { name: "Large Ranch (4oz)", price: "$3.00" },
  { name: "Medium Ranch (2oz)", price: "$2.00" },
  { name: "2oz Sauce", price: "$2.00" },
];

export const DRINKS = [
  { name: "Can Soda", price: "$2" },
  { name: "Bottled Drinks", price: "$4" },
  { name: "Bottled Water", price: "$2" },
];

export const MANIFESTO = [
  {
    num: "01",
    title: "Fresh. Never Frozen.",
    body: "Every wing and tender is hand-prepped and cooked to order. Frescas, nunca congeladas.",
  },
  {
    num: "02",
    title: "Sabor Con Sazón",
    body: "Mexican-American fusion flavor that hits different — Elote Blast, Salsa Macha, Mango Habanero.",
  },
  {
    num: "03",
    title: "Straight Outta Salinas",
    body: "A neon-green truck serving the community. Support your local wings — it means everything.",
  },
];
